import { useState } from 'react';
import styles from './CreditBalance.module.css';
import DynamicTable from '../../../../components/DynamicTable/DynamicTable';
import ClickableButton from '../../../../components/ClickableButton/ClickableButton';
import CheckboxAndData from '../../../../components/CheckboxAndData/CheckboxAndData';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../../redux/slices/modalSlice';

const CreditBalance = () => {
  const [tableData] = useState([]); // you can populate this dynamically later

  const headings = [
    { title: <CheckboxAndData />, accessor: 'checkbox' },
    { title: 'Description', accessor: 'description' },
    { title: 'Amount', accessor: 'amount' },
    { title: 'Issued Against', accessor: 'issuedAgainst' },
    { title: 'Recorded By', accessor: 'recordedBy' },
    { title: 'Reason', accessor: 'reason' },
    { title: 'Category', accessor: 'category' },
  ];

  const dispatch = useDispatch();

  return (
    <div className={styles.CreditBalance}>
      <div className={styles.buttonRow}>
        <ClickableButton label="Download Excel" />
        <ClickableButton
          label="Add Credit Balance"
          onClick={() => dispatch(openModal('addCreditBalance'))}
        />
        <ClickableButton
          label="Refund Credit Amount"
          onClick={() => dispatch(openModal('refundCreditAmount'))}
        />
      </div>

      <div className={styles.tableWrapper}>
        <DynamicTable headings={headings} columnData={tableData} />
      </div>
    </div>
  );
};

export default CreditBalance;
